import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDivider } from './Badge';
type Video = {
  url: string;
  title: string;
  caption: string;
  rotate: string;
};
const VIDEOS: Video[] = [{
  url: 'https://www.youtube.com/embed/8dNy2r5j7LQ',
  title: "Virtually Unknown — Can't You See live at Twisted Tiki",
  caption: "Can't You See — Live at Twisted Tiki, 6/28/26.",
  rotate: '1deg'
}, {
  url: 'https://www.youtube.com/embed/1BTTpgYtiy4',
  title: "Virtually Unknown — Live at Mastry's",
  caption: "Live at Mastry's — Fall 2025.",
  rotate: '-1.5deg'
}, {
  url: 'https://www.youtube.com/embed/Qbn6avnEZlA',
  title: "Virtually Unknown — Piano Man excerpt live at Mastry's",
  caption: "Piano Man (excerpt) — Live at Mastry's, Fall 2025.",
  rotate: '2deg'
}, {
  url: 'https://www.youtube.com/embed/mRpwd5A79sA',
  title: "Virtually Unknown — I Saw Her Standing There live at Mastry's",
  caption: "I Saw Her Standing There — Live at Mastry's, Fall 2025.",
  rotate: '-2deg'
}, {
  url: 'https://www.youtube.com/embed/QGBNWLqn89c',
  title: 'Virtually Unknown — Play That Funky Music live at Peridia Golf & Country Club',
  caption: 'Play That Funky Music — Live at Peridia Golf & Country Club, Winter 2025.',
  rotate: '1.5deg'
}];
export function WatchListen() {
  return <section id="watch" className="relative w-full overflow-hidden bg-[var(--vu-navy)] px-5 py-20 grain" data-id="element-154" data-mp="wbus6os2lbz4">
      <div className="relative z-10 mx-auto max-w-5xl text-center" data-id="element-155" data-mp="ncznxi8l6byg">
        <p className="mb-2 font-cond text-xs uppercase tracking-[0.4em] text-[var(--vu-gold)]" data-id="element-156" data-mp="nb6fbxeexhnt">
          Backstage Pass
        </p>
        <h2 className="font-display text-5xl uppercase leading-none text-[var(--vu-cream)] sm:text-6xl" data-id="element-157" data-mp="detlmzivb3t2">
          Watch &amp; Listen
        </h2>
        <BadgeDivider label="▶" data-id="element-158" data-mp="22ujbtczuzmci" />

        <div className="mt-6 grid grid-cols-1 gap-8 text-left sm:grid-cols-2 sm:gap-10" data-id="element-159" data-mp="22s6sowid75xv">
          {VIDEOS.map((video, index) => <motion.article key={video.url} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          rotate: 0,
          y: -4,
          zIndex: 10
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.07
        }} style={{
          rotate: video.rotate
        }} className="bg-[var(--vu-cream)] p-4 pb-6 text-center text-[var(--vu-black)] shadow-[8px_8px_0_0_var(--vu-black)] ring-2 ring-[var(--vu-black)] transition-shadow hover:shadow-[10px_10px_0_0_var(--vu-red)]" data-id="element-160" data-mp="26c7c7vyybqwn" data-mpi={index}>
              <div className="relative aspect-video overflow-hidden border border-[var(--vu-black)] bg-[var(--vu-black)]" data-id="element-161" data-mp="2fbavp12168bo">
                <iframe className="absolute inset-0 h-full w-full" src={video.url} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-162" data-mp="2bas3h5w8708y" />
              </div>
              <p className="mt-4 font-cond text-xs uppercase tracking-widest text-[var(--vu-black)]/70" data-id="element-163" data-mp="uhva2h6to5hi">
                {video.caption}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}